export default __webpack_public_path__ + "static/media/cv.2d2f09a6.svg";